<template>
  <svg
    class="custom-icon"
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
  >
    <path
      d="M14.683 10.7997L9.81691 5.68368C9.32876 5.19552 8.5373 5.19552 8.04914 5.68368L2.93304 10.7997C2.44489 11.2879 2.44489 12.0793 2.93304 12.5675C3.4212 13.0556 4.21265 13.0556 4.70081 12.5675L8.93304 8.33531L12.9152 12.5675C13.4033 13.0556 14.1948 13.0556 14.683 12.5675C15.1711 12.0793 15.1711 11.2879 14.683 10.7997Z"
    />
  </svg>
</template>
